module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"popoverHeader":"Shorten your link","destinationLink":"Destination link","shortenLink":"Shorten link","shortenError":"Unable to shorten link. Please try again.","shortenLinkLabel":"toggle link shortener"}}')
  delete Component.options._Ctor
}
